<template>
  <footer class="footer">
    <div class="container">
      <h1 class="footer__title">feel free to contact us</h1>
      <p class="footer__text">let’s start a journey</p>
      <div class="footer__details">
        <div class="footer__details__each">
          <h2>contact us</h2>
          <p>desperate.</p>
          <p><a href="mailto:contact@desperate.dk">contact@desperate.dk</a></p>
          <p>+45 4224 2116</p>
        </div>
        <div class="footer__details__each">
          <h2>location</h2>
          <p>store kirkestræde 3, 4.sal</p>
          <p>1073 københavn k</p>
          <p>denmark</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import './style.scss';

export default {
  name: 'Footer',
  data() {
    return {

    };
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue